/*
 * Rebuy: when a recommended product's selected variant is flagged out of stock
 * (custom.out_of_stock variant metafield), switch the selection to the first
 * variant that is NOT flagged out of stock, so the widget opens on a buyable
 * variant instead of getting stuck on "Sold out".
 *
 * Note: Rebuy's product.variants[] items carry metafields but NOT an `available`
 * flag, so we select by the metafield only (real inventory is unchanged anyway).
 * Requires "Enabled Variant Metafields" on the widget + a Product Cache clear.
 */
(function () {
  function isOOS(variant) {
    return !!(
      variant &&
      variant.metafields &&
      variant.metafields.custom &&
      (variant.metafields.custom.out_of_stock === true ||
        variant.metafields.custom.out_of_stock === 'true')
    );
  }

  function fixWidget(widget) {
    var data = widget && widget.data;
    var products = data && data.products;
    if (!Array.isArray(products)) return;

    products.forEach(function (product) {
      if (!product || !Array.isArray(product.variants)) return;
      if (!isOOS(product.selected_variant)) return; // current selection is buyable

      var alt = product.variants.find(function (v) {
        return v && !isOOS(v);
      });

      if (alt) {
        product.selected_variant = alt;
        product.selected_variant_id = alt.id;
      }
    });
  }

  function handler(event) {
    var detail = event && event.detail;
    fixWidget((detail && (detail.widget || detail)) || {});
  }

  ['rebuy.beforeProductsChange', 'rebuy.productsChange', 'rebuy.ready'].forEach(function (evt) {
    document.addEventListener(evt, handler);
  });
})();
